const STEP_INTERVAL_MS = 10000;

export class DialogProgressController {
    private intervalId: number | null = null;
    private readonly steps = ['Analysiere dein Bild...', 'Generiere Bild...', 'Fast fertig...'];

    constructor(
        private figureElement: HTMLElement,
        private figcaptionElement: HTMLElement
    ) {}

    public start(): void {
        this.stop();

        this.figureElement.setAttribute('aria-busy', 'true');
        this.figcaptionElement.setAttribute('aria-live', 'polite');

        let index = 0;
        this.figcaptionElement.textContent = this.steps[index];

        this.intervalId = window.setInterval(() => {
            index++;
            if (index < this.steps.length) {
                this.figcaptionElement.textContent = this.steps[index];
            } else {
                this.clearCurrentInterval();
            }
        }, STEP_INTERVAL_MS);
    }

    /*                                                               */
    public setMessage(message: string): void {
        this.figcaptionElement.textContent = message;
    }

    public stop(): void {
        this.clearCurrentInterval();
        this.figureElement.setAttribute('aria-busy', 'false');
    }

    private clearCurrentInterval(): void {
        if (this.intervalId !== null) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    }
}
